import React from 'react';
import { layout } from 'Constants';

// Components
import { Container, Anchor } from 'Components/core';
import Hero from './components/Hero';
import Cards from './components/Cards';
import InfoBox from 'Components/InfoBox';

// Images
import AppStoreIOS from 'Images/store-icon-ios.png';
import AppStoreAndroid from 'Images/store-icon-android.png';
import Connect from './images/OE_Page_Title.jpeg';
import { Subscribe } from 'laco-react';
import { ApiStore } from 'Root/store';
import CODES from 'Root/libs/analytics/CodeDef';
import Alert from './components/Alert';

export default () => (
  <Subscribe to={[ApiStore]}>
    {state => (
      <Container column>
        <Hero />
 
        <Container
          seperation="32px"
          column
          margin="32px auto"
          style={{
            maxWidth: layout.maxWidth,
            width: '100%'
          }}
        >
            {false && <Alert/>}
          <Cards />
          <InfoBox image={Connect} header="Connect to better health">
            <p>
              Once you're a member, download the <b>{state.mobileAppInfo?.appName}</b> mobile
              app today and connect to your health info wherever you are.
            </p>

            <div
              style={{
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'center'
              }}
            >
              <Anchor code={CODES.HOME_DL_APPLE} to={state.mobileAppInfo?.ios}>
                <img
                  alt="App Store"
                  style={{ alignSelf: 'center', width: 175 }}
                  src={AppStoreIOS}
                />
              </Anchor>

              <Anchor code={CODES.HOME_DL_PLAY} to={state.mobileAppInfo?.android}>
                <img
                  alt="App Store"
                  style={{ alignSelf: 'center', width: 175 }}
                  src={AppStoreAndroid}
                />
              </Anchor>
            </div>
          </InfoBox>
        </Container>
      </Container>
    )}
  </Subscribe>
);
